import moment from "moment";
import { TimeOnly } from "typings/DateTime";

export const timeToMilliseconds = (time: string) => {
   return moment.duration(time).asMilliseconds();
};

export const millisecondsToDays = (milliseconds: number) => {
   return Math.floor(milliseconds / (24 * 60 * 60 * 1000));
};

export const diffBetweenInMonths = (startDate: string, endDate?: string) => {
   const momentStartDate = moment(startDate);
   const momentEndDate = endDate ? moment(endDate) : undefined;

   return moment.duration(momentStartDate.diff(momentEndDate)).asMonths();
};

export const timeDifferenceInMinutes = (startTime: TimeOnly, endTime: TimeOnly): number => {
   const startTimeMoment = moment.duration(startTime);
   const endTimeMoment = moment.duration(endTime);
   return endTimeMoment.asMinutes() - startTimeMoment.asMinutes();
}

export const getMinutes = (time: TimeOnly | string): number => {
   var tokens = time.split(':');
   if(tokens.length > 1)
      return parseInt(tokens[1]);

   return 0;
}